module.exports = __webpack_public_path__ + "static/hero-90ef191872ce500a12fec2725b5637cf.jpg";